module.exports = __webpack_public_path__ + "static/media/first_declension_perf_eta_img.22a6253c.JPG";